module.exports = __webpack_public_path__ + "img/AUDIO_THUMBNAIL.290d58ca.svg";